import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
// Customer Layout & Pages
import { CustomerLayout } from './components/customer/CustomerLayout';
import { HomePage } from './pages/customer/HomePage';
import { LoginPage } from './pages/customer/LoginPage';
import { WalletPage } from './pages/customer/WalletPage';
import { PointsTierPage } from './pages/customer/PointsTierPage';
import { TransactionHistoryPage } from './pages/customer/TransactionHistoryPage';
import { RewardsPage } from './pages/customer/RewardsPage';
import { ReferralPage } from './pages/customer/ReferralPage';
import { ProfilePage } from './pages/customer/ProfilePage';
import { SupportPage } from './pages/customer/SupportPage';
import { CheckoutLookupPage } from './pages/customer/CheckoutLookupPage';
// Admin Layout & Pages
import { AdminLayout } from './components/admin/AdminLayout';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { DashboardPage } from './pages/admin/DashboardPage';
import { CustomersPage } from './pages/admin/CustomersPage';
import { CustomerDetailPage } from './pages/admin/CustomerDetailPage';
import { WalletRulesPage } from './pages/admin/WalletRulesPage';
import { PointsRulesPage } from './pages/admin/PointsRulesPage';
import { TiersPage } from './pages/admin/TiersPage';
import { PromotionsPage } from './pages/admin/PromotionsPage';
import { NotificationsPage } from './pages/admin/NotificationsPage';
import { ReportsPage } from './pages/admin/ReportsPage';
import { StaffRolesPage } from './pages/admin/StaffRolesPage';
import { AuditLogsPage } from './pages/admin/AuditLogsPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AuthProvider data-id="element-1">
        <Routes data-id="element-2">
          {/* Customer Portal */}
          <Route element={<CustomerLayout data-id="element-4" />} data-id="element-3">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/dang-nhap" element={<LoginPage data-id="element-8" />} data-id="element-7" />
            <Route path="/vi" element={<WalletPage data-id="element-10" />} data-id="element-9" />
            <Route path="/diem" element={<PointsTierPage data-id="element-12" />} data-id="element-11" />
            <Route path="/lich-su" element={<TransactionHistoryPage data-id="element-14" />} data-id="element-13" />
            <Route path="/phan-thuong" element={<RewardsPage data-id="element-16" />} data-id="element-15" />
            <Route path="/gioi-thieu" element={<ReferralPage data-id="element-18" />} data-id="element-17" />
            <Route path="/ho-so" element={<ProfilePage data-id="element-20" />} data-id="element-19" />
            <Route path="/ho-tro" element={<SupportPage data-id="element-22" />} data-id="element-21" />
            <Route path="/thanh-toan" element={<CheckoutLookupPage data-id="element-24" />} data-id="element-23" />
          </Route>

          {/* Admin Portal */}
          <Route path="/admin" element={<AdminLoginPage data-id="element-26" />} data-id="element-25" />
          <Route element={<AdminLayout data-id="element-28" />} data-id="element-27">
            <Route path="/admin/tong-quan" element={<DashboardPage data-id="element-30" />} data-id="element-29" />
            <Route path="/admin/khach-hang" element={<CustomersPage data-id="element-32" />} data-id="element-31" />
            <Route path="/admin/khach-hang/:id" element={<CustomerDetailPage data-id="element-34" />} data-id="element-33" />
            <Route path="/admin/vi-dien-tu" element={<WalletRulesPage data-id="element-36" />} data-id="element-35" />
            <Route path="/admin/diem" element={<PointsRulesPage data-id="element-38" />} data-id="element-37" />
            <Route path="/admin/hang" element={<TiersPage data-id="element-40" />} data-id="element-39" />
            <Route path="/admin/khuyen-mai" element={<PromotionsPage data-id="element-42" />} data-id="element-41" />
            <Route path="/admin/thong-bao" element={<NotificationsPage data-id="element-44" />} data-id="element-43" />
            <Route path="/admin/bao-cao" element={<ReportsPage data-id="element-46" />} data-id="element-45" />
            <Route path="/admin/nhan-vien" element={<StaffRolesPage data-id="element-48" />} data-id="element-47" />
            <Route path="/admin/nhat-ky" element={<AuditLogsPage data-id="element-50" />} data-id="element-49" />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-52" />} data-id="element-51" />
        </Routes>
      </AuthProvider>
    </BrowserRouter>;
}